import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { IFormBuilderAssistant } from '../../../shared/components/form-builder/form-builder-assistant/iform-builder-assistant.interface';
import { SiteHomePageDesign_FormBuilderAssistant } from './form-builder-assistant';
import { FormBuilderComponent } from '../../../shared/components/form-builder/form-builder.component';
import { FieldDefinition } from '../../../shared/models/form-builder/field-definition.model';
import { HideFromFieldType, RawHTMLFieldType, ShowToFieldType } from '../../../shared/models/form-builder/form-field-types';
import { Form } from '../../../shared/models/form-builder/form.model';
import { SiteHomePage } from '../../../shared/models/form-builder/site-home-page.model';
import { DataCollection } from '../../../shared/models/site-content/data-collection.model';
import { FieldDefinitionService } from '../../../shared/services/field-definition.service';
import { SiteHomePageService } from '../../../shared/services/site-home-page.service';

/*
// Implement a class that implements form builder interface IFormBuilderAssistant.
export class SiteHomePageDesign_FormBuilderAssistant implements IFormBuilderAssistant {
    public get initiallyExpandedFieldGroup(): string {
        return 'Guidance Fields';
    }
    public get titleCanBeConfigured(): boolean {
        return false;
    }

    public filterConditionalLogicSourceFields(fieldDefinitionService: FieldDefinitionService, formFields: FormField[]): FormField[] {
        let filteredFields: FormField[] = []; // formFields.filter(ff => ff.isMetadataField && (ff.fieldDefinitionClassName == UserRolesFieldType));
        if (formFields != null) {
            for (let index: number = 0; index < formFields.length; index++) {
                let formField: FormField = formFields[index];
                if (formField.isMetadataField) {
                    if (formField.fieldDefinitionClassName == UserRolesFieldType)
                        filteredFields.push(formField);
                } else {
                    let fieldDef: FieldDefinition = fieldDefinitionService.getFieldDefinition(formField.fieldDefinitionClassName);
                    if (fieldDef.customLogicHandler.fieldCanBeUsedInSiteHomePageConditionalLogic(formField))
                        filteredFields.push(formField);
                }
                
            }
        }
        return filteredFields;
    }

    public canEditField(fieldDefinitionService: FieldDefinitionService, formField: FormField): boolean {
        return true;
    }
    public canEditTemplateProperties(): boolean {// Applies to site home pages as well, so where the term 'Template' is used in a general way.
        return true;
    }

    // Constructor.
    public constructor() { }
}
*/

@Component({
    selector: 'app-design-homepage',
    templateUrl: './design-homepage.component.html',
    styleUrls: ['./design-homepage.component.scss'],
    standalone: false
})
export class DesignHomepageComponent implements OnInit {
    // Properties.
    private formBuilderAssistant: SiteHomePageDesign_FormBuilderAssistant = new SiteHomePageDesign_FormBuilderAssistant();
    private site: DataCollection = null;
    private homePage: SiteHomePage = null;
    private homePageForm: Form = null;
    private fieldDefinitions: FieldDefinition[] = null;

    private readonly applicableFieldNames: string[] =
    [
        RawHTMLFieldType, ShowToFieldType, HideFromFieldType
    ];

    @ViewChild('formBuilder') formBuilder: FormBuilderComponent;

    // Constructor.
    public constructor(private route: ActivatedRoute,
        private fieldDefinitionService: FieldDefinitionService,
        private siteHomePageService: SiteHomePageService,
        private readonly titleService: Title)
    {
    }

    // Life cycle methods.
    public ngOnInit(): void {   
        // Get my site and home page from my route.
        this.route.parent.data
            .subscribe((data: { currentSite: DataCollection }) => {
                this.site = data.currentSite;

                this.route.data
                    .subscribe((data: { homePage: SiteHomePage }) => {
                        this.homePage = data.homePage;

                        this.homePageForm = new Form(this.homePage);
                    });
            });

        // Retrieve and filter field definitions.
        this.fieldDefinitionService.getAll().then(response => {
            this.fieldDefinitions = response.filter(fd => fd.canBeDroppedOnSiteHomePage);
        });
        this.titleService.setTitle(this.route.snapshot.data['title'] + ' for ' + this.site.name);
    }

    // Method called by my .html code.
    public get Form(): Form {
        return this.homePageForm;
    }

    public get SiteHomePage(): SiteHomePage {
        return this.homePage;
    }

    public get FieldDefinitions(): FieldDefinition[] {
        return this.fieldDefinitions;
    }
    public get FormBuilderAssistant(): IFormBuilderAssistant {
        return this.formBuilderAssistant;
    }

    // Handle unsaved changes.
    public hasUnsavedChanges(): boolean {
        // Note:  this method is not yet implemented.
        return false;
    }

    // Handle control events.
    public saveHomePage(formBuilderComponent: FormBuilderComponent): void {
        // Construct a home page object from a form object.
        let form: Form = formBuilderComponent.Form;
        let homePage: SiteHomePage = SiteHomePage.createFromForm(form);
        homePage.isActive = this.homePage.isActive;
        homePage.showPublishFolderButton = this.homePage.showPublishFolderButton;
        homePage.showSubscribeToFolderButton = this.homePage.showSubscribeToFolderButton;

        // Save the home page.
        this.siteHomePageService.save(homePage).then((response: SiteHomePage) => {
            this.homePage = response;
            this.homePageForm = new Form(this.homePage);

            if (this.formBuilder != null)
                this.formBuilder.saveCompleted(this.homePageForm);
        });
    }
}
